import {Col, Row, TableProps} from 'antd';
import HeaderDataGrid from './header';
import OptionsDataGrid from './options';
import TableDataGrid from './table';
import './style.less';
import {ReactNode, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {
  setAddUrlDataGrid,
  setCurrentPageTableDataGrid,
  setDataTableDataGrid,
  setLabelAddButtonDataGrid,
  setSearchPlaceholderDataGrid,
  setSearchValueDataGrid,
  setShowSearchFieldDataGrid,
  setShowSearchFieldsDataGrid,
  setTitleDataGrid,
  setTitleTableDataGrid,
  setTotalTableDataGrid,
} from 'src/domain/app/redux/data-grid/data-grid-slice';

interface IDataGridProps {
  title?: string;
  showSearchField?: boolean;
  showSearchFields?: boolean;
  searchPlaceholder?: string;
  labelAddButton?: string;
  addUrl?: string;
  titleTable?: string;
  tableColumn?: any;
  tableProps?: TableProps<any>;
  optionChildren?: ReactNode;
}

const DataGrid: React.FC<IDataGridProps> = (props) => {
  const {
    title,
    showSearchField,
    showSearchFields,
    searchPlaceholder,
    labelAddButton,
    addUrl,
    titleTable,
    tableColumn,
    tableProps,
    optionChildren,
  } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setDataTableDataGrid([]));
    dispatch(setTotalTableDataGrid(0));
    dispatch(setSearchValueDataGrid(undefined));
    dispatch(setCurrentPageTableDataGrid(1));
  }, [dispatch]);

  useEffect(() => {
    dispatch(setTitleDataGrid(title));
    dispatch(setShowSearchFieldDataGrid(showSearchField));
    dispatch(setShowSearchFieldsDataGrid(showSearchFields));
    dispatch(setSearchPlaceholderDataGrid(searchPlaceholder));
    dispatch(setLabelAddButtonDataGrid(labelAddButton));
    dispatch(setAddUrlDataGrid(addUrl));
    dispatch(setTitleTableDataGrid(titleTable));
  }, [
    dispatch,
    title,
    showSearchField,
    searchPlaceholder,
    labelAddButton,
    addUrl,
    titleTable,
  ]);
  return (
    <Row className='data-grid-container' gutter={[10, 25]}>
      <Col span={24}>
        <HeaderDataGrid />
      </Col>
      <Col span={24}>
        <OptionsDataGrid optionChildren={optionChildren} />
      </Col>
      <Col span={24}>
        <TableDataGrid tableColumn={tableColumn} {...tableProps} />
      </Col>
    </Row>
  );
};

export default DataGrid;
